module.exports = __webpack_public_path__ + "img/p2.4f74a7d7.png";